import React from 'react';
import { Container, Box, Grid, Typography, Button, Card, Collapse, Checkbox, Tooltip, Input, InputAdornment, Modal } from '@material-ui/core';
import { withRouter } from 'react-router-dom'
import queryString from 'query-string';
import Select from "react-select";
import { isNull } from "util";
import Paginations from "components/Pagination/Pagination.js";
import { Map, Marker } from 'google-maps-react';
import { red } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/core/styles';
import MapInfoWindow from "./MapInfoWindow";
import PhoneIcon from '@material-ui/icons/Phone';
import LanguageIcon from '@material-ui/icons/Language';
import LocationOn from '@material-ui/icons/LocationOn';
import Email from '@material-ui/icons/Email';
import current_location from '../images/current_location.png';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import $ from "jquery"
import goldDesignation from '../images/gold.png';
import platDesignation from '../images/platinum.png';

function buildPagerItem(itemValue, reactRef) {
    if (itemValue === "PREV" || itemValue === "NEXT") {
        return { text: itemValue, onClick: () => reactRef.paginate(itemValue) };
    }

    return { active: itemValue == reactRef.state.Page ? true : false, text: itemValue + 1, onClick: () => reactRef.paginate(itemValue) }
}

var selectFirstOnEnter = function (input) {  // store the original event binding function
    var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;
    function addEventListenerWrapper(type, listener) {  // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected, and then trigger the original listener.
        if (type == "keydown") {
            var orig_listener = listener;
            listener = function (event) {
                var suggestion_selected = $(".pac-item-selected").length > 0;
                if (event.which == 13 && !suggestion_selected) {
                    var simulated_downarrow = $.Event("keydown", { keyCode: 40, which: 40 });
                    orig_listener.apply(input, [simulated_downarrow]);
                }
                orig_listener.apply(input, [event]);
            };
        }
        _addEventListener.apply(input, [type, listener]); // add the modified listener
    }
    if (input.addEventListener) {
        input.addEventListener = addEventListenerWrapper;
    } else if (input.attachEvent) {
        input.attachEvent = addEventListenerWrapper;
    }
}

const styles = theme => ({
    root: {
        maxWidth: 345,
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },
});

class ClinicSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: [],
            base_url: '',
            apibaseurl: '',
            googleapikey: '',
            searchTerm: '',
            selectedLatLng: '',
            selectedAddress: '',
            useCurLocation: false,
            locationLat: 0,
            locationLon: 0,
            Clinics: [],
            DonorEgg: 0,
            MentalHealth: 0,
            MaleCouple: 0,
            GestationalCarrier: 0,
            SingleWomen: 0,
            PGD_PGS: 0,
            DonorEmbryo: 0,
            SingleMen: 0,
            EggCryopreservation: 0,
            Cryopreservation: 0,
            FemaleCouple: 0,
            HIVPatients: 0,
            OutsideMonitoring: 0,
			LGBTQIA: 0,
            Options_MileRadius: [],
            Options_SortBy: [],
            Options_PageSize: [],
            MileRadius: 500,
            SortBy: 0,
            PageSize: 20,
            TotalPages: 0,
            Page: 0,
            selectedClinicID: 0,
            selectedSatelliteID: 0,
            showAdvancedSearchOptions: false,
            showingInfoWindow: false,  //Hides or the shows the infoWindow
            activeMarker: {},          //Shows the active marker upon click
            selectedPlaceName: '',
            selectedPlaceAddr: '',
            selectedPlaceCID: 0,
            selectedPlaceSID: 0,
            openValidation: false,
            validationMessage: '',
            openDesignationLegend: false
        };
        this.retrieveData = this.retrieveData.bind(this);
        this.currentLocation = this.currentLocation.bind(this);
        this.paginate = this.paginate.bind(this);
        this.handleMileRadiusChange = this.handleMileRadiusChange.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.handleSortByChange = this.handleSortByChange.bind(this);
        this.handleFilterChanged = this.handleFilterChanged.bind(this);
        this.handleLocTextManualChange = this.handleLocTextManualChange.bind(this);
        this.handleAdvancedSearchChanged = this.handleAdvancedSearchChanged.bind(this);
        this.handleExpandClick = this.handleExpandClick.bind(this);
        this.onMarkerClick = this.onMarkerClick.bind(this);
        this.onMarkerInfoClose = this.onMarkerInfoClose.bind(this);
        this.navigateToSelectedClinicDetails = this.navigateToSelectedClinicDetails.bind(this);
        this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
        this.inputInterval = null;
        this.autocomplete = null;
        this.handleCloseValidation = this.handleCloseValidation.bind(this);
        this.handleOpenDesignationLegend = this.handleOpenDesignationLegend.bind(this);
        this.handleCloseDesignationLegend = this.handleCloseDesignationLegend.bind(this);
        this.applySearch = this.applySearch.bind(this);
        this.callClinic = this.callClinic.bind(this);
        this.webClinic = this.webClinic.bind(this);
        this.emailClinic = this.emailClinic.bind(this);
        this.locateClinic = this.locateClinic.bind(this);
    }

    handleCloseValidation() {
        this.setState({
            openValidation: false,
        })
    }

    handleOpenDesignationLegend() {
        this.setState({
            openDesignationLegend: true,
        })
    }

    handleCloseDesignationLegend() {
        this.setState({
            openDesignationLegend: false,
        })
    }

    handleFilterChanged(event) {
        const target = event.target;
        const value = target.type == 'checkbox' ? target.checked : target.value;
        const name = target.name;
        if (target.type == 'text') {
            this.props.ga_event('Clinic Search', 'Location / Keyword Filter Changed');
            this.setState({
                [name]: value
            });

            clearTimeout(this.inputInterval);
            this.inputInterval = setTimeout(() => {
                this.setState({
                    Page: 0
                }, this.retrieveData)
            }, 500);
        }
        else {
            this.props.ga_event('Clinic Search', 'Checkbox Filter Changed');
            this.setState({
                [name]: value,
                Page: 0
            }, this.retrieveData);
        }
    }

    handleLocTextManualChange(event) {
        const target = event.target;
        const value = target.type == 'checkbox' ? target.checked : target.value;
        if (target.type == 'text') {
            if (value == "") {
                this.setState({
                    locationLat: 0,
                    locationLon: 0,
                    SortBy: 1,
                    Page: 0
                }, this.retrieveData);
            }
        }
    }

    onMarkerClick(props, marker, e) {
        this.props.ga_event('Clinic Search', 'Map Marker Clicked');

        this.setState({
            selectedPlaceName: props.name.split("|!|")[0],
            selectedPlaceAddr: props.address,
            selectedPlaceCID: parseInt(props.name.split("|!|")[1]),
            selectedPlaceSID: parseInt(props.name.split("|!|")[2]),
            activeMarker: marker,
            showingInfoWindow: true
        });
    }

    onMarkerInfoClose(props) {
        this.props.ga_event('Clinic Search', 'Map Marker Info Popup Closed');

        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };

    componentDidMount() {
        selectFirstOnEnter(document.getElementById('autocomplete'));
        this.autocomplete = new window.google.maps.places.Autocomplete(document.getElementById('autocomplete'), {
            types: ['geocode']
        })
        this.autocomplete.addListener("place_changed", this.handlePlaceSelect);
        let params = queryString.parse(this.props.location.search);
        document.getElementById('autocomplete').value = params.Addr;

        let baseapi = this.props.apibaseurl;
        let googleapikey = this.props.googleapikey;
        let base_url = this.props.base_url;

        this.setState({
            base_url: base_url,
            apibaseurl: baseapi,
            googleapikey: googleapikey
        });

        setTimeout(function () {
            $(".pac-container").prependTo(".clinicSearchContainer");
        }, 300);

        if (params)
        {
            this.setState({
                locationLat: params.Lat,
                locationLon: params.Lon,
                selectedAddress: params.Addr,
                useCurLocation: params.Addr == "Current Location",
                DonorEgg: params.DonorEgg == "true" ? true : false,
                MentalHealth: params.MentalHealth == "true" ? true : false,
                MaleCouple: params.MaleCouple === "true" ? true : false,
                GestationalCarrier: params.GestationalCarrier == "true" ? true : false,
                SingleWomen: params.SingleWomen == "true" ? true : false,
                PGD_PGS: params.PGD_PGS == "true" ? true : false,
                DonorEmbryo: params.DonorEmbryo == "true" ? true : false,
                SingleMen: params.SingleMen == "true" ? true : false,
                EggCryopreservation: params.EggCryopreservation == "true" ? true : false,
                Cryopreservation: params.Cryopreservation == "true" ? true : false,
                FemaleCouple: params.FemaleCouple == "true" ? true : false,
                HIVPatients: params.HIVPatients == "true" ? true : false,
                OutsideMonitoring: params.OutsideMonitoring == "true" ? true : false,
				LGBTQIA: params.LGBTQIA == "true" ? true : false,
                MileRadius: params.MileRadius ? params.MileRadius : 500,
                SortBy: params.Lat != 0 && params.Lon != 0 ? (params.SortBy ? params.SortBy : 0) : 1,
                PageSize: params.PageSize ? params.PageSize : 20,
                Page: params.Page ? params.Page : 0,
                searchTerm: params.SearchTerm ? params.SearchTerm : ""
            }, this.retrieveData);

            this.props.ga_pageview(window.location.pathname);
        }
        else
        {
            // user must select location to load the inital search page
            window.location = this.state.base_url + "/Search";
        }
    }

    componentWillUnmount() {
        if (this.inputInterval) {
            clearInterval(this.inputInterval);
        }
    }

    handlePlaceSelect() {
        this.props.ga_event('Clinic Search', 'New Address Selected');

        let place = this.autocomplete.getPlace()
        let address = place.formatted_address;
        let lat = place.geometry.location.lat();
        let lon = place.geometry.location.lng();

        this.setState({
            selectedAddress: address,
            locationLat: lat,
            locationLon: lon,
            useCurLocation: false,
            Page: 0,
            SortBy: 0
        }, this.retrieveData);
    }

    async currentLocation() {
        this.props.ga_event('Clinic Search', 'Current Location Selected');

        if ("geolocation" in navigator) {
            await navigator.geolocation.getCurrentPosition(
                position =>
                {
                    if (!position.coords.latitude || !position.coords.longitude || position.coords.latitude == 0 || position.coords.longitude == 0)
                    {
                        this.setState({
                            openValidation: true,
                            validationMessage: 'Your location could not be determined. Check if location services is enabled, or type your location instead.'
                        });
                    }
                    else
                    {
                        this.setState({
                            useCurLocation: true,
                            locationLat: position.coords.latitude,
                            locationLon: position.coords.longitude,
                            selectedAddress: "Current Location",
                            Page: 0,
                        }, this.retrieveData);

                        document.getElementById('autocomplete').value = "Current Location";
                    }
                },
                err => this.setState({
                    openValidation: true,
                    validationMessage: 'Your location could not be determined. Check if location services is enabled, or type your location instead.'
                })
            );
        }
        else {
            this.setState({
                openValidation: true,
                validationMessage: 'Your location could not be determined. Check if location services is enabled, or type your location instead.'
            });
        }
    }

    applySearch() {
        this.setState({
            Page: 0
        }, this.retrieveData);
    }

    retrieveData() {
        let endpoint = this.state.apibaseurl + "Membersearch/ClinicSearch";
        let parambody = JSON.stringify({
            SearchTerm: this.state.searchTerm,
            Latitude: this.state.locationLat,
            Longitude: this.state.locationLon,
            DonorEgg: this.state.DonorEgg,
            MaleCouple: this.state.MaleCouple,
            MentalHealth: this.state.MentalHealth,
            GestationalCarrier: this.state.GestationalCarrier,
            SingleWomen: this.state.SingleWomen,
            PGD_PGS: this.state.PGD_PGS,
            DonorEmbryo: this.state.DonorEmbryo,
            SingleMen: this.state.SingleMen,
            EggCryopreservation: this.state.EggCryopreservation,
            Cryopreservation: this.state.Cryopreservation,
            FemaleCouple: this.state.FemaleCouple,
            HIVPatients: this.state.HIVPatients,
            OutsideMonitoring: this.state.OutsideMonitoring,
			LGBTQIA: this.state.LGBTQIA,
            MileRadius: this.state.MileRadius,
            SortBy: this.state.SortBy,
            TotalPages: this.state.TotalPages,
            Page: this.state.Page,
            PageSize: this.state.PageSize
        });

        fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: parambody
        }).then(res => res.json())
            .then((result) => {
                if (result && result.Clinics) {
                    this.setState({
                        Clinics: result.Clinics,
                        Options_MileRadius: result.Options_MileRadius,
                        Options_SortBy: result.Options_SortBy,
                        Options_PageSize: result.Options_PageSize,
                        TotalPages: result.TotalPages,
                        expanded: [],
                    });
                }
            },
            (error) =>
            {
                console.log("INSIDE ERROR");
            }
        );
    }

    navigateToContactClinic(clinicId, name) {
        this.props.ga_event('Clinic Search', 'Contact Clinic Button Clicked', name);

        var url = "https://www.sartcorsonline.com/Home/RequestClinicInfo?clinicId=" + clinicId;

        var win = window.open(url, '_blank');
        if (win) {
            win.focus();
        }
    }

    navigateToClinicCSR(clinicId, goodStandingPendingValidation, pendingValidation, name) {
        this.props.ga_event('Clinic Search', 'Success Rates Button Clicked', name);

        var url = "https://sartcorsonline.com/CSR/PublicSnapshotReport?ClinicPKID=" + clinicId + "&reportingYear=2023";
        if (pendingValidation) {
            url = "https://www.sart.org/Data_Being_Validated/";
        }
        else if (goodStandingPendingValidation) {
            url = "http://www.sart.org/SART_Clinic_In_Good_Standing/";
        }

        var win = window.open(url, '_blank');
        if (win) {
            win.focus();
        }
    }

    navigateToClinicDetails(clinicId, satelliteId, name) {
        this.props.ga_event('Clinic Search', 'Clinic Details Button Clicked', name);

        var address = this.state.useCurLocation ? 'Current Location' : this.state.selectedAddress;
        var searchWithParamsURL = this.state.base_url + "/Clinic?ID=" + clinicId
            + "&SatID=" + satelliteId
            + "&Lat=" + this.state.locationLat
            + "&Lon=" + this.state.locationLon
            + "&SearchTerm=" + this.state.searchTerm
            + "&Addr=" + address
            + "&DonorEgg=" + this.state.DonorEgg
            + "&MaleCouple=" + this.state.MaleCouple
            + "&MentalHealth=" + this.state.MentalHealth
            + "&GestationalCarrier=" + this.state.GestationalCarrier
            + "&SingleWomen=" + this.state.SingleWomen
            + "&PGD_PGS=" + this.state.PGD_PGS
            + "&DonorEmbryo=" + this.state.DonorEmbryo
            + "&SingleMen=" + this.state.SingleMen
            + "&EggCryopreservation=" + this.state.EggCryopreservation
            + "&Cryopreservation=" + this.state.Cryopreservation
            + "&FemaleCouple=" + this.state.FemaleCouple
            + "&HIVPatients=" + this.state.HIVPatients
            + "&OutsideMonitoring=" + this.state.OutsideMonitoring
			+ "&LGBTQIA=" + this.state.LGBTQIA
            + "&MileRadius=" + this.state.MileRadius
            + "&SortBy=" + this.state.SortBy
            + "&Page=" + this.state.Page
            + "&PageSize=" + this.state.PageSize;

        window.location = searchWithParamsURL;
    }

    navigateToSelectedClinicDetails() {
        this.navigateToClinicDetails(this.state.selectedPlaceCID, this.state.selectedPlaceSID);
    };

    handleMileRadiusChange(item) {
        this.props.ga_event('Clinic Search', 'Search Radius Changed', item.value);

        if (isNull(item.value) || item.value == '') { item.value = 0; }
        this.setState({
            MileRadius: item.value, force: false,
            Page: 0,
        }, this.retrieveData);
    }

    handlePageSizeChange(item) {
        this.props.ga_event('Clinic Search', 'Page Size Changed', item.value);

        if (isNull(item.value) || item.value == '') { item.value = 0; }
        this.setState({
            PageSize: item.value,
            Page: 0,
        }, this.retrieveData);
    }

    handleSortByChange(item) {
        this.props.ga_event('Clinic Search', 'Sort By Changed', item.value);

        if (isNull(item.value) || item.value == '') { item.value = 1; }
        if (item.value == 0 && (this.state.locationLat == 0 || this.state.locationLon == 0)) {
            item.value = 1;
            this.setState({
                openValidation: true,
                validationMessage: 'Please select a location to order by distance.'
            }, this.retrieveData);
        }
        if (item.value == this.state.SortBy) { return; }
        this.setState({
            SortBy: item.value,
            Page: 0,
        }, this.retrieveData);
    }

    paginate(target) {
        this.props.ga_event('Clinic Search', 'Pagination Button Clicked');
        if (target == "PREV") {
            this.setState({
                Page: this.state.Page-1
            }, this.retrieveData);
        }
        else if (target == "NEXT") {
            this.setState({
                Page: this.state.Page + 1
            }, this.retrieveData);
        }
        else {
            this.setState({
                Page: target
            }, this.retrieveData);
        }
    }

    handleExpandClick(i, name) {
        var expandedStateCopy = Array.from(this.state.expanded);
        var idx = expandedStateCopy.indexOf(i);
        if (idx > -1) {
            this.props.ga_event('Clinic Search', 'Clinic Details Collapsed', name);
            expandedStateCopy.splice(idx, 1);
            this.setState({
                expanded: expandedStateCopy
            });
        }
        else {
            this.props.ga_event('Clinic Search', 'Clinic Details Expanded', name);
            expandedStateCopy.push(i);
            this.setState({
                expanded: expandedStateCopy
            });
        }
    }

    locateClinic(target, name) {
        this.props.ga_event('Clinic Search', 'Clinic Address Clicked', name);
        if (target) {
            target = 'https://www.google.com/maps/search/?api=1&query=' + target.trim();
        }
        else {
            return;
        }

        var win = window.open(target, '_blank');
        if (win) {
            win.focus();
        }
    }

    webClinic(target, name) {
        this.props.ga_event('Clinic Search', 'Clinic Website Clicked', name);
        if (!target.startsWith("http://") && !target.startsWith("https://")) {
            target = "https://" + target;
        }
        var win = window.open(target, '_blank');
        if (win) {
            win.focus();
        }
    }

    emailClinic(target, name) {
        this.props.ga_event('Clinic Search', 'Clinic Email Clicked', name);
        if (target) {
            target = 'mailto:' + target.trim();
        }
        else {
            return;
        }
        window.open(target, '_self');
    }

    callClinic(target, name) {
        this.props.ga_event('Clinic Search', 'Clinic Phone Clicked', name);
        if (target) {
            target = 'tel:' + target.trim().replace(/\D/g, '');
        }
        else {
            return;
        }
        window.open(target, '_self');
    }

    handleAdvancedSearchChanged(event) {
        this.props.ga_event('Clinic Search', 'Advanced Search Area Expanded');

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    render() {
        let milesRadiusPicked = null;
        if (this.state.Options_MileRadius) {
            milesRadiusPicked = this.state.Options_MileRadius.find(option => option.value == this.state.MileRadius);
        }

        let sortByPicked = null;
        if (this.state.Options_SortBy) {
            sortByPicked = this.state.Options_SortBy.find(option => option.value == this.state.SortBy);
        }

        let pageSizePicked = null;
        if (this.state.Options_PageSize) {
            pageSizePicked = this.state.Options_PageSize.find(option => option.value == this.state.PageSize);
        }

        let pageSet = [];
        // for now show all pages. show prev/next only if applicable.
        if (this.state.Page > 0) {
            pageSet.push(buildPagerItem("PREV", this));
        }
        for (var i = 0; i < this.state.TotalPages; i++) {
            pageSet.push(buildPagerItem(i, this));
        }
        if (this.state.Page != (this.state.TotalPages - 1) && this.state.TotalPages != 0) {
            pageSet.push(buildPagerItem("NEXT", this));
        }

        return (
            <Box className="clinicSearchContainer">
                <Container maxWidth={false}>
                    <Container maxWidth="xl" style={{ paddingTop: '.67em' }}>
                        <Grid container
                            className="paddingWeb20Mobile5"
                            direction="row"
                            spacing={1}
                            justify="flex-start"
                            alignItems="center">
                            <Grid item sm={5} xs={12} className="homeInputContainer">
                                <Input id="autocomplete"
                                    className="autocomplete topInput"
                                    ref="input"
                                    type="text"
                                    onChange={this.handleLocTextManualChange}
                                    placeholder="Enter location or use icon to the right"
                                    endAdornment={
                                        <Tooltip title="Use Current Location" arrow>
                                            <InputAdornment position="end">
                                                <MyLocationIcon onClick={this.currentLocation} />
                                            </InputAdornment>
                                        </Tooltip>
                                    }
                                />
                            </Grid>
                            <Grid item sm={5} xs={12} className="homeInputContainer">
                                <Input id="searchTerm"
                                    name="searchTerm"
                                    className="autocomplete bottomInput"
                                    type="text"
                                    value={this.state.searchTerm}
                                    placeholder="Clinic name or keywords"
                                    onChange={this.handleFilterChanged} />
                            </Grid>
                            <Grid item sm={2} xs={12}>
                                <Button variant="contained" color="primary" onClick={this.applySearch} disableElevation style={{ width: "100%", height: "48px" }}>Search</Button>
                            </Grid>
                        </Grid>
                        <br /><br />
                        <Grid container
                            className="paddingWeb20Mobile5"
                            direction="row"
                            spacing={3}
                            justify="center"
                            alignItems="flex-start">
                            <Grid item sm={3} xs={12}>
                                <Box style={{ backgroundColor: "white", position: 'relative', height: "400px", marginBottom: "20px" }}>
                                    <Map
                                        google={window.google}
                                        zoom={ this.state.locationLat != 0 && this.state.locationLat != 0 ? 9 : 3 }
                                        style={{ width: '100%', height: '400px' }}
                                        center={{
                                            lat: this.state.locationLat != 0 && this.state.locationLat != 0 ? this.state.locationLat : 39.809072,
                                            lng: this.state.locationLat != 0 && this.state.locationLat != 0 ? this.state.locationLon : -98.555545
                                        }}>
                                        { this.state.locationLat != 0 && this.state.locationLat != 0 &&
                                            <Marker
                                                onClick={this.onMarkerClick}
                                                name={'Current Location'}
                                                position={{ lat: this.state.locationLat, lng: this.state.locationLon }}
                                                icon={{
                                                    url: current_location,
                                                    scaledSize: new window.google.maps.Size(25, 40)
                                                }}
                                            />
                                        }
                                        {this.state.Clinics && this.state.Clinics.map((cl, idx) => ([
                                            <Marker key={idx}
                                                onClick={this.onMarkerClick}
                                                name={cl.Name + "|!|" + cl.ClinicID + "|!|" + cl.SatelliteID}
                                                address={cl.DisplayFullAddress}
                                                position={{ lat: cl.Latitude, lng: cl.Longitude }}
                                            />
                                        ]))}
                                        <MapInfoWindow
                                            marker={this.state.activeMarker}
                                            visible={this.state.showingInfoWindow}
                                            onClose={this.onClose}>
                                            <Box>
                                                <Typography variant="h6">
                                                    {this.state.selectedPlaceName}
                                                </Typography>
                                                <Typography variant="body2">
                                                    {this.state.selectedPlaceAddr}
                                                </Typography>
                                                {this.state.selectedPlaceName !== "Current Location" && 
                                                    <button style={{}} onClick={this.navigateToSelectedClinicDetails}>Clinic Details</button>
                                                }
                                            </Box>
                                        </MapInfoWindow>
                                    </Map>
                                </Box>
                                <Box>
                                    <Checkbox
                                        checked={this.state.advancedSearch}
                                        name="showAdvancedSearchOptions"
                                        onChange={this.handleAdvancedSearchChanged}
                                    /> Show Advanced Search
                                    { this.state.showAdvancedSearchOptions &&
                                        <div>
                                            <Typography variant="h5" gutterBottom>
                                                Services
                                            </Typography>
                                            <Grid container
                                                className="paddingWeb20Mobile5"
                                                direction="row" spacing={1}
                                                justify="flex-start" alignItems="flex-start">
                                                <Grid item xs={12} sm={6}>
                                                    <input type="checkbox" checked={this.state.DonorEgg} name="DonorEgg" onChange={this.handleFilterChanged} className="form-control" />
                                                    <label>Donor Egg</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <input type="checkbox" checked={this.state.MentalHealth} name="MentalHealth" onChange={this.handleFilterChanged} className="form-control" />
                                                    <label>Mental Health</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <input type="checkbox" checked={this.state.MaleCouple} name="MaleCouple" onChange={this.handleFilterChanged} className="form-control" />
                                                    <label>Male Couple</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <input type="checkbox" checked={this.state.GestationalCarrier} name="GestationalCarrier" onChange={this.handleFilterChanged} className="form-control" />
                                                    <label>Gestational Carrier</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <input type="checkbox" checked={this.state.EggCryopreservation} name="EggCryopreservation" onChange={this.handleFilterChanged} className="form-control" />
                                                    <label>Egg Cryopreservation</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <input type="checkbox" checked={this.state.SingleWomen} name="SingleWomen" onChange={this.handleFilterChanged} className="form-control" />
                                                    <label>Single Women</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <input type="checkbox" checked={this.state.PGD_PGS} name="PGD_PGS" onChange={this.handleFilterChanged} className="form-control" />
                                                    <label>PGT</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <input type="checkbox" checked={this.state.DonorEmbryo} name="DonorEmbryo" onChange={this.handleFilterChanged} className="form-control" />
                                                    <label>Donor Embryo</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <input type="checkbox" checked={this.state.SingleMen} name="SingleMen" onChange={this.handleFilterChanged} className="form-control" />
                                                    <label>Single Men</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <input type="checkbox" checked={this.state.Cryopreservation} name="Cryopreservation" onChange={this.handleFilterChanged} className="form-control" />
                                                    <label>Embryo Cryopreservation</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <input type="checkbox" checked={this.state.FemaleCouple} name="FemaleCouple" onChange={this.handleFilterChanged} className="form-control" />
                                                    <label>Female Couple</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <input type="checkbox" checked={this.state.HIVPatients} name="HIVPatients" onChange={this.handleFilterChanged} className="form-control" />
                                                    <label>HIV Patients</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                <input type="checkbox" checked={this.state.OutsideMonitoring} name="OutsideMonitoring" onChange={this.handleFilterChanged} className="form-control" />
                                                    <label>Outside Monitoring</label>
                                                </Grid>
												<Grid item xs={12} sm={6}>
                                                <input type="checkbox" checked={this.state.LGBTQIA} name="LGBTQIA" onChange={this.handleFilterChanged} className="form-control" />
                                                    <label>LGBTQIA</label>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    }
                                </Box>
                            </Grid>
                            <Grid item sm={9} xs={12}>
                                <Box>
                                    <Grid container
                                        className="paddingWeb20Mobile5"
                                        direction="row"
                                        spacing={1}
                                        justify="flex-start"
                                        alignItems="flex-start">
                                        <Grid item xs={4}>
                                            <label>Results / Page</label>
                                            <Select
                                                name="SelectPageSize"
                                                closeMenuOnSelect={true}
                                                options={this.state.Options_PageSize}
                                                value={pageSizePicked}
                                                onChange={this.handlePageSizeChange}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <label>Range</label>
                                            <Select
                                                name="SelectMileRadius"
                                                closeMenuOnSelect={true}
                                                options={this.state.Options_MileRadius}
                                                value={milesRadiusPicked}
                                                onChange={this.handleMileRadiusChange}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <label>Sort</label>
                                            <Select
                                                name="SelectSortBy"
                                                closeMenuOnSelect={true}
                                                options={this.state.Options_SortBy}
                                                value={sortByPicked}
                                                onChange={this.handleSortByChange}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container
                                        className="paddingWeb20Mobile5"
                                        direction="row"
                                        spacing={1}
                                        justify="space-around"
                                        alignItems="center"
                                        style={{ textAlign: "center" }}>
                                        <Grid item xs={12}>
                                            <Paginations style={{ display:"inline-block"}}
                                                pages={pageSet}
                                                color="primary"
                                            />
                                        </Grid>
                                    </Grid>
                                    {(!this.state.Clinics || !this.state.Clinics.length) &&
                                        <Grid container
                                            className="paddingWeb20Mobile5"
                                            direction="row"
                                            spacing={1}
                                            justify="space-around"
                                            alignItems="center"
                                            style={{ textAlign: "center" }}>
                                            <Grid item xs={12}>
                                                <Box className="infoSection">
                                                    <Typography variant="h6" className="infoHeader">We Couldn't Find Anything Matching Your Search</Typography>
                                                    <Typography variant="subtitle1" className="infoHeader">Broaden your search by increasing the range, choosing a different location, or using fewer keywords.</Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    }
                                    
                                    {this.state.Clinics && this.state.Clinics.map((cl, idx) => (
                                    <Card className="clinicCard" key={idx} style={{ marginBottom: "20px" }}>
                                        <Grid container
                                            direction="row"
                                            spacing={1}
                                            justify="space-evenly"
                                            alignItems="flex-start">
                                            <Grid item xs={12} sm={3}>
                                                <Box style={{ width: "100%" }}>
                                                    <img
                                                        src={this.state.apibaseurl + "Membersearch/ClinicLogo?clinicId=" + cl.ClinicID}
                                                        alt="Clinic Logo"
                                                        className="clinicLogoList"
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={9}>
                                                <Grid container
                                                    direction="row"
                                                    spacing={1}
                                                    justify="center"
                                                    alignItems="flex-start">
                                                        <Grid item xs={12} sm={9} style={{ marginBottom: "10px" }}>
                                                            <h3 className="cardTitle" style={{ margin: "0px" }}>{cl.Name}</h3>
                                                            <h6 className="clinicCerts" style={{ marginTop:"0px", marginBottom: "10px" }}>
                                                                {cl.CertsAndAccredidations && cl.CertsAndAccredidations.map((cert, idx) => (
                                                                    <span key={idx}>{(idx ? ' | ' : '') + cert}</span>
                                                                ))}
                                                            </h6>
                                                            <Grid item xs={12} sm={9}>
                                                                <Grid container
                                                                    direction="row"
                                                                    spacing={1}
                                                                    justify="center"
                                                                    alignItems="flex-start">
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <table className="iconRowTable">
                                                                        <tbody>
                                                                            {cl.FullAddress &&
                                                                                <tr className="cursorHand">
                                                                                    <td> <LocationOn color="primary" /></td>
                                                                                    <td>
                                                                                        <Typography variant="body2" display="inline" gutterBottom onClick={() => this.locateClinic(cl.FullAddress, cl.Name)}>
                                                                                            {cl.DisplayFullAddress}
                                                                                        </Typography>
                                                                                    </td>
                                                                                </tr>
                                                                            }
                                                                            {cl.Email &&
                                                                                <tr className="cursorHand">
                                                                                    <td><Email color="primary" /></td>
                                                                                    <td>
                                                                                        <Typography variant="body2" display="inline" gutterBottom onClick={() => this.emailClinic(cl.Email, cl.Name)}>
                                                                                            {cl.Email}
                                                                                        </Typography>
                                                                                    </td>
                                                                                </tr>
                                                                            }
                                                                            {cl.Phone &&
                                                                                <tr className="cursorHand">
                                                                                    <td><PhoneIcon  color="primary" /></td>
                                                                                    <td>
                                                                                        <Typography variant="body2" display="inline" gutterBottom onClick={() => this.callClinic(cl.Phone, cl.Name)}>
                                                                                            {cl.Phone}
                                                                                        </Typography>
                                                                                    </td>
                                                                                </tr>
                                                                            }
                                                                            {cl.Website &&
                                                                                <tr className="cursorHand"> 
                                                                                    <td><LanguageIcon color="primary" /></td>
                                                                                    <td>
                                                                                        <Typography variant="body2" display="inline" gutterBottom onClick={() => this.webClinic(cl.Website, cl.Name)}>
                                                                                            {cl.Website}
                                                                                        </Typography>
                                                                                    </td>
                                                                                </tr>
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    <Grid item xs={12} sm={3}>
                                                        <Box className="rowButtons">
                                                            <Button
                                                                className="rowButton"
                                                                style={{ width: "100%" }}
                                                                variant="contained"
                                                                color="default"
                                                                onClick={() => this.navigateToContactClinic(cl.ClinicID, cl.Name)}
                                                                disableElevation>
                                                                Contact Clinic
                                                            </Button>
                                                            <br />
                                                            <Button
                                                                className="rowButton"
                                                                style={{ marginTop: "5px", width: "100%" }}
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={() => this.navigateToClinicCSR(cl.ClinicID, cl.InGoodStanding, cl.IsValidationPending, cl.Name)}
                                                                disableElevation>
                                                                Success Rates
                                                            </Button>
                                                            <br />
                                                            {this.state.expanded.indexOf(idx) > -1 &&
                                                            <Box>
                                                                <Button
                                                                    className="rowButton"
                                                                    style={{ marginTop: "5px", width: "100%" }}
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={() => this.navigateToClinicDetails(cl.ClinicID, cl.SatelliteID, cl.Name)}
                                                                    disableElevation>
                                                                    Details
                                                                </Button>
                                                                <br />
                                                            </Box>
                                                            }
                                                            { this.state.locationLat != 0 && this.state.locationLat != 0 &&
                                                                <p style={{ margin: "0px", fontWeight: "bold" }}>{cl.DistanceDisplay}</p>
                                                            }
                                                            <Grid container
                                                                direction="row"
                                                                spacing={1}
                                                                justify="space-around"
                                                                alignItems="center"
                                                                style={{ textAlign: "center" }}>
                                                                <Grid item xs={12}>
                                                                    {cl.ClinicDesignationID == 1 &&
                                                                        <img src={goldDesignation} alt="Gold" onClick={this.handleOpenDesignationLegend} className="smLink badgeIcon" />
                                                                    }
                                                                    {cl.ClinicDesignationID == 2 &&
                                                                        <img src={platDesignation} alt="Platinum" onClick={this.handleOpenDesignationLegend} className="smLink badgeIcon" />
                                                                    }
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    </Grid>
                                                    </Grid>

                                                <Grid container
                                                    direction="row"
                                                    spacing={1}
                                                    justify="center"
                                                    alignItems="flex-start">
                                                    <Grid item xs={12}>
                                                        <Collapse in={this.state.expanded.indexOf(idx) > -1 } timeout={0} unmountOnExit>
                                                            <Grid container
                                                                direction="row"
                                                                spacing={1}
                                                                justify="center"
                                                                alignItems="flex-start">
                                                                <Grid item xs={12}>
                                                                    {cl.Overview &&
                                                                    <Box className="infoSection">
                                                                        <Typography variant="h6" className="infoHeader">Overview</Typography>
                                                                        <p style={{ margin: "0px" }}>{cl.Overview}</p>
                                                                    </Box>
                                                                    }
                                                                    {(cl.Services && (cl.Services.length > 0)) &&
                                                                    <Box className="infoSection">
                                                                        <Typography variant="h6" className="infoHeader">Services</Typography>
                                                                        {cl.Services.map((service, idx) => (
                                                                            <span key={idx}>{(idx ? ', ' : '') + service}</span>
                                                                        ))}
                                                                    </Box>
                                                                    }
                                                                    {cl.Members && cl.Members.length > 0 &&
                                                                    <Box className="infoSection">
                                                                        <Typography variant="h6" className="infoHeader">Providers</Typography>
                                                                        {cl.Members.map((mem, idx) => (
                                                                            <p key={idx} className="providerLabel">{mem.Role}: {mem.NameFirstLast + " " + mem.Title}</p>
                                                                        ))}
                                                                    </Box>
                                                                    }
                                                                    {(cl.Specializations && (cl.Specializations.length > 0)) &&
                                                                    <Box className="infoSection">
                                                                        <Typography variant="h6" className="infoHeader">Other Services</Typography>
                                                                        {cl.Specializations.map((spec, idx) => (
                                                                            <span key={idx}>{(idx ? ', ' : '') + spec}</span>
                                                                        ))}
                                                                    </Box>
                                                                    }
                                                                    {cl.MemberSince &&
                                                                    <Box className="infoSection">
                                                                        <Typography variant="h6" className="infoHeader">{cl.MemberSince}</Typography>
                                                                    </Box>
                                                                    }
                                                                </Grid>
                                                            </Grid>
                                                        </Collapse>
                                                        </Grid>
                                                        <Grid item xs={12} style={{ textAlign: "center"}} >
                                                        { this.state.expanded.indexOf(idx) <= -1 &&
                                                            <Button
                                                                className="clinicCardExpander"
                                                                variant="contained"
                                                                color="default"
                                                                onClick={() => this.handleExpandClick(idx, cl.Name)}
                                                                disableElevation>
                                                                More
                                                            </Button>
                                                        }
                                                        { this.state.expanded.indexOf(idx) > -1 &&
                                                            <Button
                                                                className="clinicCardExpander"
                                                                variant="contained"
                                                                color="default"
                                                                onClick={() => this.handleExpandClick(idx, cl.Name)}
                                                                disableElevation>
                                                                Less
                                                            </Button>
                                                        }
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                    ))}
                                    <Grid container
                                        className="paddingWeb20Mobile5"
                                        direction="row"
                                        spacing={1}
                                        justify="space-around"
                                        alignItems="center"
                                        style={{ textAlign: "center" }}>
                                        <Grid item xs={12}>
                                            <Paginations style={{ display: "inline-block" }}
                                                pages={pageSet}
                                                color="primary"
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>
                    </Container>
                </Container>
                <Modal
                    open={this.state.openValidation}
                    onClose={this.handleCloseValidation}>
                    <div className="modalStyle" >
                        <div className="modalBody" style={{ textAlign: "center" }}>
                            <h4 className="infoHeader">{this.state.validationMessage}</h4>
                        </div>
                        <hr />
                        <div className="modalFooter">
                            <Button style={{ float: "right", marginBottom: "10px" }} variant="contained" color="primary" onClick={this.handleCloseValidation}>Close</Button>
                        </div>
                    </div >
                </Modal>
                <Modal
                    open={this.state.openDesignationLegend}
                    onClose={this.handleCloseDesignationLegend}>
                    <div className="modalStyle" >
                        <div className="modalBody" style={{ textAlign: "center" }}>
                            <h2 className="infoHeader">Clinic Designation Legend</h2>
                        </div>
                        <Grid container
                            className="paddingWeb20Mobile5"
                            direction="row"
                            spacing={1}
                            justify="space-around"
                            alignItems="center"
                            style={{ textAlign: "center" }}>
                            <Grid item xs={12} sm={3}>
                                <img src={goldDesignation} alt="Gold" className="smLink badgeIcon" />
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                GOLD DESIGATION DESCRIPTION
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <img src={platDesignation} alt="Gold" className="smLink badgeIcon" />
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                PLATINUM DESIGATION DESCRIPTION
                            </Grid>
                        </Grid>
                        <hr />
                        <div className="modalFooter">
                            <Button style={{ float: "right", marginBottom: "10px" }} variant="contained" color="primary" onClick={this.handleCloseDesignationLegend}>Close</Button>
                        </div>
                    </div >
                </Modal>
            </Box>
        );
    }
}
 
export default withStyles(styles)((withRouter(ClinicSearch)));